<template>
    <div class="field--url display--grid page--single__half">
        <base-field
            class="field--url__input"
            :class="fieldClass"
            :settings="settings"
        />
        <router-link
            v-if="anchor.see"
            :to="anchor.url"
            class="field--url__anchor capitalize"
            :class="{ 'disable': anchor.disable }"
        >
            {{ $t(`global.${anchor.translationKey}`) }}
        </router-link>
    </div>
</template>

<script>
export default {
    components: {
        BaseField: () => import( /* webpackChunkName: 'BaseField'  */ '@/components/bundles/fields/BaseField' )
    },
    props: {
        fieldClass: String,
        settings: Object,
        anchor: Object
    }
};
</script>

<style lang="scss">
    .field {
        &--url {
            &__anchor {
                width: max-content;
                margin-top: 35px;
            }
        }
    }
</style>